import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const ListContainer = styled.div`
  margin: 0;
  max-height: 55vh;
  min-height: 100px;
  height: 250px;
  min-width: 300px;
  width: 100%;
  overflow-y: auto;
  /* position: absolute; */
  .list-items {
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    min-height: 64px;
    border-bottom: 1px solid ${Variables.colors.complementary_300};
    display: flex;
    justify-content: space-between;
    //align-items: center;
    .text-bar {
      min-height: 62px;
      display: flex;
      margin-top: 8px;
      align-items: flex-start;
      flex-direction: column;
      position: relative;
      .project-characteristics {
        display: flex;
        align-items: center;
        width: 100%;
        .project-name {
          font-size: ${Variables.font_sizes.x2_medium};
          color: ${Variables.colors.complementary_900};
          line-height: 1.56;
          padding-right: 16px;
          margin-bottom: 2px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: calc(150px);
          //width: 100%;
          //overflow-wrap: break-word;
          .inner-text {
            //max-width: calc(264px - 94px - 36px);
            //word-break: break-word;
          }
        }
      }

      .user-name {
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_600};
        line-height: 1.58;
        padding-right: 16px;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        direction: ltr;
      }
      .list-items-icon {
        position: absolute;
        right: 16px;
        top: calc(50% - 10px);
        margin-left: 16px;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:before {
          margin: 0;
          font-size: 16px;
          color: ${Variables.colors.black};
        }
      }
    }
    .icon-bar {
      //height: 64px;
      min-width: 24px;
      display: flex;
      .list-items-more-icon {
        position: absolute;
        left: 8px;
        top: 8px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: none;
        justify-content: center;
        align-items: center;
        &:before {
          margin: 0;
          font-size: 16px;
          color: ${Variables.colors.complementary_600};
        }
        &.pressed,
        &:hover {
          background-color: ${Variables.colors.complementary_300};
        }
      }
      .list-items-more-icon-disabled {
        &:before {
          margin: 0;
          font-size: 16px;
          color: ${Variables.colors.complementary_400};
        }
      }
      .project-invite {
        //float: left;
        background-color: ${Variables.colors.primary_500};
        width: 79px;
        height: 24px;
        border-radius: 4px;
        color: ${Variables.colors.complementary};
        font-size: ${Variables.font_sizes.x_small};
        text-align: center;
        line-height: 22px;
        margin-top: 8px;
        margin-left: 8px;
      }
    }
    &:hover {
      background-color: ${Variables.colors.primary_50};
      .list-items-more-icon {
        display: flex;
      }
    }
  }
`;

export const Footer = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: calc(464px - 79px - 16px); */
`;

export const Box = styled.div`
  min-width: 280px;
  max-width: 448px;
  //width: 100%;
  margin: 0 16px;
  border-radius: 4px;
  .logo {
    width: 100%;
    text-align: center;
    img {
      width: 42px;
    }
  }
  h2 {
    color: ${Variables.colors.complementary_800};
    font-size: 28px;
    font-weight: 500;
    width: 100%;
    text-align: center;
    margin-bottom: 72px;
  }
  .user-box {
    border-bottom: solid 1px ${Variables.colors.complementary_300};
    padding: 10px 0;
    margin: -42px -42px 10px -42px;
    text-align: center;
    font-size: ${Variables.font_sizes.x2_medium};
    i {
      background-color: ${Variables.colors.green};
      color: ${Variables.colors.complementary};
      margin: 0 6px;
      width: 24px;
      height: 24px;
      display: inline-block;
      padding: 2px 6px;
      border-radius: 14px;
      &:before {
        font-size: ${Variables.font_sizes.small};
      }
    }
  }
  .back {
    float: left;
    margin-left: -36px;
    cursor: pointer;
  }
  .left-logo {
    line-height: 36px;
    img {
      width: 42px;
      float: right;
      margin-left: 16px;
    }
  }
  form {
    margin-top: 32px;
  }
  .field {
    display: flex;
    width: 100%;
    margin-top: 16px;
    div {
      width: 100%;
    }
    .side-icon {
      line-height: 36px;
      color: ${Variables.colors.complementary_600};
      &:before {
        font-size: ${Variables.font_sizes.x2_medium};
        margin-left: 10px;
      }
    }
    .inner-field {
      display: flex;
      width: 100%;
      margin-top: 10px;
    }
    .field-label {
      margin-top: 16px;
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_600};
    }
    .column-2{
      margin-right: 8px;
      &>div{
        height: unset;
      }
    }
  }
  .text {
    color: ${Variables.colors.complementary_500};
    font-size: ${Variables.font_sizes.x_small};
    padding-top: 16px;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
  }
`;
const COLORS = {
  success: {
    background: Variables.colors.green_100,
    text: Variables.colors.green_800
  },
  secondary: {
    background: Variables.colors.complementary_400,
    text: Variables.colors.complementary_700
  }
};
export const TagBox = styled.div`
  background-color: ${props => COLORS[props.type].background};
  color: ${props => COLORS[props.type].text};
  font-size: ${Variables.font_sizes.x_small};
  border-radius: 14px;
  height: 24px;
  margin-right: 10px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 8px;
  font-weight: ${Variables.font_weight.medium};
  //white-space: nowrap;
`;
